/**
 * NotFoundPage
 * Fallback route for unknown URLs in the SPA router.
 */
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <section className="gradient_panel_text">
      <div className="panel_text">
        <h1>Page not found</h1>
        <p>The route you requested does not exist.</p>
        <Link to="/">Return home</Link>
      </div>
    </section>
  );
}
